<template>
  <base-container ref="container" :isLoading="loading">
    <ArtisanGrid
      ref="record"
      metaKey="BedRecordInfo"
      :metaInited="metaInited"
      :handleQuery="handleQuery"
      @regainRegister="regainRegister"
      @viewBedDetail="viewBedDetail"
      @bedCancel="bedCancel"
      @againSend="againSendMsg"
      :rowBtnPermission="rowBtnPermission"
      :query="{ status: status }"
    >
      <template #gridBtnBefore>
        <el-radio-group v-model="status" size="mini">
          <el-radio-button label=""> 全部 </el-radio-button>
          <el-radio-button
            v-for="item in statusList"
            :key="item.value"
            :label="item.value"
          >
            {{ item.label }}
          </el-radio-button>
        </el-radio-group>
      </template>
      <template #status="{ row, label }">
        <el-tag :type="statusType[row.status]" effect="dark" size="small">
          {{ label }}
        </el-tag>
      </template>
      <template #reserveDate="{ row }">
        <span v-if="row.status == 'audit' || row.status == 'yes'">
          {{ row.reserveDate }}
        </span>
        <span v-else></span>
      </template>
      <template #patientGender="{ row }">
        <span>{{ row.patientGender == "1" ? "男" : "女" }}</span>
      </template>
      <template #createTimeSearch>
        <el-date-picker
          style="width: 100%"
          size="mini"
          v-model="filterDate"
          type="daterange"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          :clearable="false"
          valueFormat="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>
      <template #reserveDateSearch>
        <el-date-picker
          style="width: 100%"
          size="mini"
          v-model="reserveDate"
          type="date"
          valueFormat="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>
      <template #inlineRemark="{ row }">
        <span>{{ row.inlineRemark }}</span
        ><el-button
          icon="el-icon-edit"
          type="text"
          @click="toEditInlineRemark(row)"
          >编辑</el-button
        >
      </template>
    </ArtisanGrid>
    <artisan-dialog
      :title="dialog.title"
      :visible.sync="dialog.show"
      height="75%"
      width="75%"
      ref="drawer"
    >
      <el-row v-if="dialog.show" style="height: 100%">
        <el-col style="height: 100%; background-color: white" :span="8">
          <artisan-group style="height: 100%" title="入院卡信息">
            <RecordDetail :record="record"></RecordDetail>
          </artisan-group>
        </el-col>
        <el-col style="height: 100%; padding: 0 5px" :span="16">
          <artisan-group style="height: 100%" title="轨迹节点">
            <RecordLog :recordId="record.id"></RecordLog>
          </artisan-group>
        </el-col>
      </el-row>
    </artisan-dialog>
    <artisan-dialog
      :title="redialog.title"
      :visible.sync="redialog.show"
      width="500px"
      height="270px"
      ref="dialog"
      :isLoading="redialog.loading"
    >
      <el-checkbox v-model="record.obeyAdjustGroup">是否服从调组</el-checkbox>
      <el-checkbox v-model="record.obeyAdjustHos">是否服从调院区</el-checkbox>
      <el-input
        class="margin-v5"
        type="textarea"
        :rows="5"
        placeholder="其他"
        v-model="record.inlineRemark"
        maxlength="100"
        show-word-limit
      >
      </el-input>
      <template #footer>
        <el-button
          type="primary"
          icon="el-icon-check"
          size="mini"
          @click="confirm"
        >
          确认
        </el-button>
      </template>
    </artisan-dialog>
    <artisan-dialog
      :title="againDialog.title"
      :visible.sync="againDialog.show"
      width="600px"
      height="130px"
      ref="againDialog"
    >
      <artisan-group
        v-if="againDialog.show"
        style="height: 100%"
        title="请选择部分消息事件类型"
      >
        <div class="align-center">
          <el-radio-group v-model="msgEventType">
            <el-radio
              v-for="msgEventType in msgEventTypes"
              :key="msgEventType.value"
              :label="msgEventType.value"
              >{{ msgEventType.label }}
            </el-radio>
          </el-radio-group>
        </div>
      </artisan-group>
      <template #footer>
        <el-button
          type="primary"
          icon="el-icon-check"
          size="mini"
          @click="confirmAgainSend"
        >
          确认
        </el-button>
      </template>
    </artisan-dialog>
    <artisan-dialog
      :title="inlineDialog.title"
      :visible.sync="inlineDialog.show"
      width="600px"
      height="400px"
      ref="inlineDialog"
    >
      <artisan-group
        v-if="inlineDialog.show"
        style="height: 100%"
        title="请输入内容"
      >
        <textarea
          style="height: 97%;width: 100%;padding: 10px;"
          v-model="inlineRemark"
          placeholder="请输入内容"
        ></textarea>
      </artisan-group>
      <template #footer>
        <el-button
          type="primary"
          icon="el-icon-check"
          size="mini"
          @click="confirmEdit"
        >
          确认
        </el-button>
      </template>
    </artisan-dialog>
  </base-container>
</template>

<script>
import moment from "moment";
import { reRegiter, cancel } from "@/api/bed/reserve";
import { againSend,editInlineRemark } from "@/api/bed/record";
import RecordDetail from "./RecordDetail.vue";
import RecordLog from "./RecordLog.vue";
import { loadEnum } from "@/api/sys/dicType";
export default {
  components: { RecordDetail, RecordLog },
  props: ["query"],
  data() {
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    return {
      loading: false,
      status: this.query.status || "",
      reserveDate: "",
      filterDate: [start, new Date()],
      record: {},
      dialog: {
        title: "",
        show: false,
      },
      redialog: {
        title: "",
        show: false,
      },
      againDialog: {
        title: "",
        show: false,
      },
      inlineDialog: {
        title: "",
        show: false,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近一月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近三月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      statusType: {
        inline: "info",
        audit: "warning",
        other: "warning",
        yes: "primary",
        no: "danger",
        in: "success",
      },
      statusList: [],
      msgEventTypes: [],
      msgEventType: "",
      inlineRemark: "",
    };
  },
  watch: {
    status() {
      this.$refs.record.reload({ status: this.status });
    },
  },
  created() {
    loadEnum("BedRecordStatusOption").then((res) => {
      this.statusList = res.data.data;
    });
    loadEnum("BedMsgEventTypeOption").then((res) => {
      this.msgEventTypes = res.data.data;
    });
  },
  methods: {
    metaInited(option) {
      option.columns.find((c) => c.code == "createTime").searchSlot = true;
      option.columns.find((c) => c.code == "reserveDate").searchSlot = true;
    },
    relaod() {
      this.$refs.record.relaod();
    },
    rowBtnPermission(row, btn) {
      if (btn.code == "regainRegister") {
        return row.status == "no" || row.status == "other";
      }
      if (btn.code == "bedCancel") {
        return row.status != "no" && row.status != "in";
      } else {
        return btn.code == "viewBedDetail" || btn.code == "againSend";
      }
    },
    handleQuery(param) {
      if (this.filterDate.length) {
        let start = moment(this.filterDate[0]).format("YYYY-MM-DD");
        let end = moment(this.filterDate[1]).format("YYYY-MM-DD");
        param.createTime = start + " 00:00:00," + end + " 23:59:59";
      }
      if (this.reserveDate) {
        param.reserveDate = this.reserveDate;
      }
      return param;
    },
    regainRegister(row) {
      this.record = row;
      this.redialog.title = "重新登记--" + row.patientName;
      this.redialog.show = true;
    },
    confirm() {
      this.$refs.dialog.confirm({ msg: "确认重新登记？" }).then(() => {
        this.redialog.loading = true;
        reRegiter(
          this.record.id,
          this.record.obeyAdjust,
          this.record.inlineRemark
        )
          .then(() => {
            this.$message({
              type: "success",
              message: "重新登记成功！",
            });
            this.redialog.show = false;
            this.redialog.loading = false;
            this.$refs.record.reload();
          })
          .catch(() => {
            this.redialog.loading = false;
          });
      });
    },
    viewBedDetail(row) {
      this.record = row;
      this.dialog.title = "预约详情--" + row.patientName;
      this.dialog.show = true;
    },
    bedCancel(row) {
      this.$refs.container
        .confirm({ msg: "确认患者要取消入院吗？" })
        .then(() => {
          this.loading = true;
          cancel(row.id)
            .then(() => {
              this.$message({
                type: "success",
                message: "取消入院成功！",
              });
              this.loading = false;
              this.$refs.record.reload();
            })
            .catch(() => {
              this.loading = false;
            });
        });
    },
    againSendMsg(row) {
      this.record = row;
      this.againDialog.title = "补发消息--" + row.patientName;
      this.againDialog.show = true;
    },
    confirmAgainSend() {
      againSend(this.record.id, this.msgEventType).then(() => {
        this.againDialog.show = false;
        this.$message({
          type: "success",
          message: "消息发送中,有一定的延迟，请稍后...",
        });
      });
    },
    toEditInlineRemark(row) {
      this.record = row;
      this.inlineRemark=row.inlineRemark;
      this.inlineDialog.title = "内容编辑--" + row.patientName;
      this.inlineDialog.show = true;
    },
    confirmEdit() {
      this.$refs.container
        .confirm({ msg: "确认修改内容？" })
        .then(() => {
          this.loading = true;
          editInlineRemark(this.record.id,this.inlineRemark)
            .then(() => {
              this.$message({
                type: "success",
                message: "编辑成功！",
              });
              this.inlineDialog.show = false;
              this.loading = false;
              this.record.inlineRemark=this.inlineRemark;
            })
            .catch(() => {
              this.loading = false;
            });
        });
    },
  },
};
</script>

<style></style>
